var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "action_toolbar",
      staticClass: "section-action-button-container exception",
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "mt-2 section-action-buttons disable-selection no-print",
          attrs: { id: `section-action-buttons-${_vm.sectionId}` },
        },
        [
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { icon: "", small: "", rounded: "" },
              on: { click: _vm.copyTextClicked },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "trigger-copy-action text--secondary",
                  attrs: { "aria-label": "Copy text" },
                },
                [_vm._v("\n                mdi-content-copy\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { icon: "", small: "", rounded: "" },
              on: { click: _vm.bookmarkClicked },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "trigger-bookmark-action text--secondary",
                  attrs: { "aria-label": "Add note or bookmark" },
                },
                [
                  _vm._v(
                    "\n                mdi-bookmark-plus-outline\n            "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticClass: "mr-2",
              attrs: { icon: "", small: "", rounded: "" },
              on: { click: _vm.printClicked },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "trigger-print-action text--secondary",
                  attrs: { "aria-label": "Print" },
                },
                [_vm._v("\n                mdi-printer-outline\n            ")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              attrs: { icon: "", small: "", rounded: "" },
              on: { click: _vm.copyLinkClicked },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "trigger-share-action text--secondary",
                  attrs: { "aria-label": "Copy link" },
                },
                [_vm._v("\n                mdi-link\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "mt-2 section-action-button-mobile disable-selection" },
        [
          _c(
            "v-btn",
            {
              staticClass: "float-right section-action-menu-trigger-mobile",
              attrs: { icon: "", text: "", rounded: "" },
              on: { click: _vm.mobileActionFiredIcon },
            },
            [
              _c(
                "v-icon",
                {
                  staticClass: "notranslate",
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v("\n                mdi-dots-vertical\n            ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }